import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-8 pb-12 sm:pt-16 sm:pb-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-104">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-105">
        <div className="absolute top-[-10%] right-[-5%] w-[50%] h-[50%] rounded-full bg-sage/10 blur-3xl" data-id="element-106"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-[60%] h-[60%] rounded-full bg-sage/5 blur-3xl" data-id="element-107"></div>
      </div>

      <div className="max-w-5xl mx-auto" data-id="element-108">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-12 items-center" data-id="element-109">
          <FadeIn direction="right" className="order-2 lg:order-1" data-id="element-110">
            <div className="space-y-4 sm:space-y-8" data-id="element-111">
              <div className="inline-block px-3 py-1 sm:px-4 sm:py-1.5 rounded-full bg-sage/20 text-sage-dark font-medium text-xs sm:text-sm tracking-wide" data-id="element-112">
                Para mujeres de 40+ años
              </div>

              <h1 className="text-2xl sm:text-5xl lg:text-6xl font-bold leading-tight text-charcoal" data-id="element-113">
                Cómo Eliminar los Sofocos, Desinflamar tu Abdomen y Equilibrar
                tu Humor en{' '}
                <span className="text-sage-dark italic" data-id="element-114">30 Días</span>
              </h1>

              <p className="text-base sm:text-2xl font-serif text-charcoal-light italic" data-id="element-115">
                Sin Dietas de Hambre — Incluso Si Sientes que tu Metabolismo se
                Detuvo por Completo.
              </p>

              <div className="h-px w-16 sm:w-24 bg-sage/50" data-id="element-116"></div>

              <p className="text-sm sm:text-lg text-charcoal-light leading-relaxed" data-id="element-117">
                Descubre el Protocolo de Reinicio Hormonal diseñado
                específicamente para mujeres de 40+ que están cansadas de no
                reconocerse en el espejo y quieren recuperar su energía vital
                HOY mismo.
              </p>

              <div className="pt-2 sm:pt-4" data-id="element-118">
                <CTAButton data-id="element-119" />
              </div>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} className="order-1 lg:order-2 relative" data-id="element-120">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl w-full sm:max-w-md mx-auto lg:h-[600px]" data-id="element-121">
              <img src="https://cdn.magicpatterns.com/uploads/msHtgY88YouBYucF16Fmu9/reinicioo_hormonass.png" alt="Mujer sintiéndose en paz y equilibrada - Reinicio Hormonal 40+" className="w-full h-auto sm:h-full sm:object-cover" data-id="element-122" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/40 to-transparent" data-id="element-123"></div>
            </div>

            {/* Floating badge - hidden on small mobile */}
            <div className="hidden sm:block absolute -bottom-6 -left-6 sm:-left-10 bg-white p-3 sm:p-4 rounded-xl shadow-xl border border-cream-dark max-w-[200px] animate-bounce" style={{
            animationDuration: '3s'
          }} data-id="element-124">
              <div className="flex items-center gap-3" data-id="element-125">
                <div className="flex -space-x-2" data-id="element-126">
                  {[1, 2, 3].map(i => <div key={i} className="w-8 h-8 rounded-full bg-sage-light border-2 border-white flex items-center justify-center text-white text-xs font-bold" data-id="element-127">
                      {i === 1 ? 'M' : i === 2 ? 'L' : 'C'}
                    </div>)}
                </div>
                <div className="text-xs font-medium text-charcoal-light leading-tight" data-id="element-128">
                  <span className="font-bold text-charcoal block" data-id="element-129">+10,000</span>
                  mujeres transformadas
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}